export default __webpack_public_path__ + "static/media/isyncbrain_logo.c1b072d8.png";